export class ValidationResult {
    ErrorMessage: string;
    MemberNames: string[];
}


// WEBPACK FOOTER //
// ./src/app/data/framework/validationResult.ts